import { useQuery } from "@tanstack/react-query";
import { ComunicacionAjax } from "../../ts/api/comunicacion";

export function useOpcionesCategoria() {
	return useQuery({
		queryKey: ["opcionesCategorizacion"],
		queryFn: () => {
			const url = "/api/v1/opcionesCategorizacion";
			return ComunicacionAjax.sendAjaxRequest<OpcionesCategorias>("GET", url, {});
		},
	});
}
export interface OpcionesCategorias {
	categorias: string[];
	gamas: string[];
	tipos: string[];
	subtipos: string[];
	tamanos: string[];
}

export function useMapeos() {
	return useQuery({
		queryKey: ["mapeoArticulos"],
		queryFn: () => {
			const url = "/api/v1/mapeoArticulos";
			return ComunicacionAjax.sendAjaxRequest<{ mapeoArticulos: MapeoArticuloRaw[]; }>("GET", url, {})
				.then(res => Object.values(res.mapeoArticulos));
		},
	});
}
export interface MapeoArticuloRaw {
	id: number;
	idArticulo: number;
	idFamilia: string;
	categoria: string;
	gama: string;
	tipo: string;
	subtipo: string;
	tamano: string;
}